import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

import { LogoutMenuItem } from './LogoutMenuItem';


export function UserAsideMenu() {
  const intl = useIntl()


 

  return (
    <>
      <AsideMenuItem
  to='/dashboard'
  icon='/media/icons/duotune/general/gen025.svg'
  title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
/>


<div className='menu-item'>
  <div className='menu-content pt-8 pb-2'>
    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Marketing</span>
  </div>
</div>

<AsideMenuItem to='/analytics' title='Analytics' icon='/media/icons/duotune/graphs/gra006.svg' />
<AsideMenuItem to='/marketing/google-ads' title='Google Ads' icon='/media/icons/duotune/finance/fin010.svg' />
<AsideMenuItem to='/marketing/mass-email' title='Mass email' icon='/media/icons/duotune/communication/com011.svg' />
<AsideMenuItem to='/website-submissions' title='Website Submissions' icon='/media/icons/duotune/communication/com003.svg' />

<div className='menu-item'>
  <div className='menu-content pt-8 pb-2'>
    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>CRM</span>
  </div>
</div>

  <AsideMenuItem to='/contacts' title='Contacts' icon='/media/icons/duotune/communication/com005.svg' />
  <AsideMenuItem to='/monthly-support' title='Monthly support' icon='/media/icons/duotune/general/gen055.svg' />

<div className='menu-item'>
  <div className='menu-content pt-8 pb-2'>  
    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Accounting</span>
  </div>
</div>

  <AsideMenuItem to='/accounting' title='Invoices & Bills' icon='/media/icons/duotune/finance/fin002.svg' exact />
  <AsideMenuItem to='/recurring-payments' title='Recurring Payments' icon='/media/icons/duotune/finance/fin006.svg' />
  <AsideMenuItem to='/accounting/cashflow' title='Cash Flow' icon='/media/icons/duotune/finance/fin008.svg' />
  <AsideMenuItem to='/banking' title='Bank Reconciliation' icon='/media/icons/duotune/finance/fin010.svg' />

<div className='menu-item'>
  <div className='menu-content'>
    <div className='separator mx-1 my-4'></div>
  </div>
</div>

<div className='menu-item'>
  <div className='menu-content pt-2 pb-2'>
    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Account & Security</span>
  </div>
</div>
  
  <AsideMenuItem
    to='/user/account/settings'
    title='Settings'
    icon='\media\icons\duotune\general\gen019.svg'
  />
  <LogoutMenuItem title='Sign Out' icon='\media\icons\custom\lock.svg' />



    </>
  )
}
